import { render } from "./FormGridColumn.vue?vue&type=template&id=03b8aa4b&ts=true"
import script from "./FormGridColumn.ts?vue&type=script&lang=ts&external"
export * from "./FormGridColumn.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__